<template>
    <div class="paging-flex">
        <div class="inline-flex ml-md-auto">
            <i class="icon-three-bars paging-icon"/>
            <select class="form-control select" ref="select2" data-fouc>
                <option v-for="page in pageInfo.pages" :key="page" :value="page">{{page}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Paging",
        props: ['pageInfo'],
        data() {
            return {
            }
        },
        computed: {
            target: function() {
                return $(this.$refs.select2)
            },
        },
        mounted() {
            let vue = this
            this.target.select2({
                minimumResultsForSearch: Infinity
            });
            this.target.on('select2:select', function (e) {
                vue.$emit('search',e.params.data.id - 1)
            });
        },
        watch: {
            'pageInfo':function(val) {
                this.target.val(val.page + 1).trigger('change')
            }
        }

    }
</script>

<style scoped>
    .paging-flex {
        display: flex;
        /*padding: 22px;*/
    }
    .inline-flex {
        display: inline-flex;
    }
    .inline-flex .btn-flex {
        border: 1px solid transparent;
        padding: .4375rem .875rem;
        border-radius: 3px 0px 0px 3px;
        font-weight: 300;
    }
    .paging-icon {
        font-size:1.5rem !important;
        top:7px !important;
    }
</style>
